/**
 * App.js
 * Application Root Node
 *
 * @jsx React.DOM
 *
 */

import React from 'react';
import {
	// Paper
	Paper,
	// Flexbox
	Container,
	Block,
	FontIcon,
	// Navbar
	Navbar,
	NavLink,
	NavDropDown,
	NavMenu,
	// Sticky Header
	StickyHeader,
	Header,
	// List Item
	ListContainer,
	ListItem,
	// Buttons
	IconButton,
	FlatButton,
	FlatSplitButton,
	RaisedButton,
	RaisedSplitButton,
	// Card
	FancyCard,
	// Code Block
	CodeBlock,
	// Dialog
	Dialog,
	ProgressBar,
	// Charts
	Charts,
	// Text Field
	TextField,
	// Flash Messages
	FlashContainer,
	FlashMessage,
	// Forms
	Autocomplete,
	Input,
	RadioGroup,
	Radio,
	Toggle,
	Checkbox,
	Snackbar,
	Divider,
	DatePicker,
	DataGrid,
	Table,
	Column,
	Toolbar,
	Chips,
	ToolbarGroup,
	OffCanvas,
	// Tabs
	Tabs,
	Tab
} from '../src';

import CssEvent from 'utils/css-event';

const flashMessageHeight = 43;

export default React.createClass({

	displayName: 'ComponentsView',

	getInitialState() {
		return({
			flashMessages: [{
				text: "I'm a a really cool FlashMessage",
				type: "success",
				animated: true,
				depth: 1,
				zIndex: 100,
				key: 0,
				onMessageClick: this._handleFlashMessageClick,
			}],
			toggleDisable: true
		});
	},

	componentDidMount() {
		this.refs.errorTextField.setErrorText('This field is required');
	},

	componentDidUpdate() {

	},

	render() {

		return (
			<div>
				<div>

					<FancyCard headerTitle="Table" headerSubtitle="A simple table component">
						<Container>
							<Block alignItems="center">
								<Paper>
									{this._renderTable()}
								</Paper>
							</Block>
						</Container>
					</FancyCard>

					<FancyCard headerTitle="Progress Bar" headerSubtitle="An animated progress bar component" tools={this._getProgressBarTools()}>
						<Container>
							<Block alignItems="center">
								<Paper>
									{this._renderProgressBar()}
								</Paper>
							</Block>
						</Container>
					</FancyCard>

					<FancyCard headerTitle="Chips" headerSubtitle="A multi-select chip component">
						<Container>
							<Block padded={true} alignItems="center">
								<Paper>
									{this._renderChips()}
								</Paper>
							</Block>
						</Container>
					</FancyCard>

					<FancyCard headerTitle="Typography" headerSubtitle="An example of typographical rhythym">
						{this._renderTypography()}
					</FancyCard>

					<FancyCard headerTitle="Divider" headerSubtitle="A divided list container component">
						<Container>
							<Block padded={true} alignItems="center">
								{this._renderDivider()}
							</Block>
						</Container>
					</FancyCard>

					<FancyCard headerTitle="Paper" headerSubtitle="A base paper component, also known as material">
						{this._renderPaper()}
					</FancyCard>

					<FancyCard headerTitle="Buttons" headerSubtitle="Various button components">
						{this._renderButtons()}
					</FancyCard>

					<FancyCard headerTitle="Date Picker" headerSubtitle="A fully interactive date picking component">
						<Container justifyContent="center">
							<Block width="300px" >
								{this._renderDatePicker()}
							</Block>
						</Container>
					</FancyCard>

					<FancyCard headerTitle="Snackbar" headerSubtitle="A snackbar notificational pop-up component">
						{this._renderSnackbarTrigger()}
					</FancyCard>

					<FancyCard headerTitle="Forms" headerSubtitle="Various different form elements">
						{this._renderForms()}
					</FancyCard>

					<FancyCard headerTitle="Font Icon" headerSubtitle="Simple icon component" tools={this._getFontTools()}>
						{this._renderFontIcon()}
					</FancyCard>

					<FancyCard headerTitle="Fancy Card" headerSubtitle="A fanciful and feature rich card component" tools={this._getFancyCardTools()}>
						{this._renderFancyCard()}
					</FancyCard>

					<FancyCard headerTitle="Sticky Header" headerSubtitle="Sticky category scroll component">
						{this._renderStickyHeader()}
					</FancyCard>

					<FancyCard headerTitle="List" headerSubtitle="Extremely feature rich ListContainer component">
						{this._renderList()}
					</FancyCard>

					<FancyCard headerTitle="Dialog" headerSubtitle="Various customizable dialog components">
						{this._renderDialog()}
					</FancyCard>

					<FancyCard headerTitle="Tabs" headerSubtitle="A robust tab component">
						{this._renderTabs()}
					</FancyCard>

				</div>
				{this._renderToolbar()}
			</div>
		);
	},

	///////////
	// Table //
	///////////

	_renderTable() {
		var rows = [
			['old, test', 'in', 'active', 'JPMC', '192.168.111.222', '1234', 'Cantor Fitzgerald', '192.168.111.222', '4321', '33/s', '436kb/s', '.03s'],
			['new, test', 'in', 'active', 'JPMC', '192.168.111.222', '1234', 'Cantor Fitzgerald', '192.168.111.222', '4321', '33/s', '436kb/s', '.03s'],
			['new, test', 'in', 'active', 'JPMC', '192.168.111.222', '1234', 'Cantor Fitzgerald', '192.168.111.222', '4321', '33/s', '436kb/s', '.03s'],

		];

		function rowGetter(rowIndex) {
			return rows[rowIndex];
		}

		return (
			<Table
			rowGetter={rowGetter}
			rowsCount={rows.length}
			width={1000}
			height={125}
			headerHeight={35}
			rowHeight={30}>
				<Column
					flexGrow={1}
					label="Tags"
					width={70}
					dataKey={0} />
				<Column
					flexGrow={1}
					label="In/Out"
					width={50}
					dataKey={1} />
				<Column
					flexGrow={1}
					label="Status"
					width={50}
					dataKey={2} />
				<Column
					flexGrow={1}
					label="Source Company"
					width={110}
					dataKey={3} />
				<Column
					flexGrow={1}
					label="Source IP"
					width={110}
					dataKey={4} />
				<Column
					flexGrow={1}
					label="Source Port"
					width={80}
					dataKey={5} />
				<Column
					flexGrow={1}
					label="Dest. Company"
					width={120}
					dataKey={6} />
				<Column
					flexGrow={1}
					label="Dest. IP"
					width={110}
					dataKey={7} />
				<Column
					flexGrow={1}
					label="Dest. Port"
					width={70}
					dataKey={8} />
				<Column
					flexGrow={1}
					label="Packets/s"
					width={80}
					dataKey={9} />
				<Column
					flexGrow={1}
					label="Bandwidth"
					width={80}
					dataKey={10} />
				<Column
					flexGrow={1}
					label="RTT"
					width={50}
					dataKey={11} />
			</Table>
		)
	},

	//////////////////
	// Progress Bar //
	//////////////////

	_renderProgressBar() {

		let paddingTop = {
			paddingTop: '0'
		};

		return(
			<Container flexDirection="column">
				<Block width="100%" margin={false} padded={true} style={paddingTop} height="50px">
					<ProgressBar ref="progressBar" />
				</Block>
				<Block width="100%" padded={true}>
					<Container>
						<Block width="200px" margin={true}>
							<TextField
								ref="barInput"
								name="Bar %"
								onEnterKeyDown={this._setPercent} />
						</Block>
						<Block width="150px" margin={true}>
							<RaisedButton label="Set Progress" onClick={this._setPercent} />
						</Block>
					</Container>
				</Block>
			</Container>
		);
	},

	_getProgressBarTools() {
		return(
			<span>
				<IconButton icon="refresh" onClick={this._progressStart} tooltip="Start" />
				<IconButton icon="times" onClick={this._progressDone} tooltip="Done" />
			</span>
		);
	},

	_progressStart() {
		this.refs.progressBar.start();
	},

	_progressDone() {
		this.refs.progressBar.done();
	},

	_progressAdd() {
		this.refs.progressBar.addButton();
	},

	_setPercent() {
		this.refs.progressBar.toPercent(this.refs.barInput.getValue());
	},

	///////////
	// Chips //
	///////////

	_renderChips() {
		return (
			<div>
				<Chips />
			</div>
		)
	},

	///////////////////
	// FlashMessage  //
	///////////////////

	_renderFlashMessage(){
		let flashMessages = this.state.flashMessages.map(function(message, i) {
			return <FlashMessage
					key={message.key}
					uuid={i}
					animated={message.animated}
					text={message.text}
					type={message.type}
					zIndex={message.zIndex}
					onMessageClick={message.onMessageClick}
					onDismiss={this._handleDismiss}
					closeCustomFontIcon={message.closeCustomFontIcon} />
		}.bind(this));

		return (
			<FlashContainer>
				{flashMessages}
			</FlashContainer>
		);
	},

	_handleAddFlash() {
		var data = this.state.flashMessages.slice(0); // Clone this.state.flashMessages array
		// Push to cloned array
		data.push({
				text: 'I am a NEW Flash Message',
				animated: true,
				type: 'notice',
				depth: 1,
				zIndex: this.state.flashMessages.length ? this.state.flashMessages[this.state.flashMessages.length-1].zIndex-1 : 100, // zIndex of the last child in array -1
				onMessageClick: this._handleFlashMessageClick,
				key: this.state.flashMessages.length ? this.state.flashMessages[this.state.flashMessages.length-1].key+1 : 0 // get key of last child in array and +1
			})

		// Set the cloned array as the new array.
		this.setState({
			flashMessages: data
		});
	},

	_handleDismiss(index) {
		console.log(index);
		var data = this.state.flashMessages;
		data.splice(index, 1);

		this.setState({ flashMessages: data });
	},

	_getFlashMessageTools() {
		return(
			<span>
				<IconButton onClick={this._handleAddFlash} icon="dot-circle-o" tooltip="Add Flash Message" />
			</span>
		);
	},

	_handleFlashMessageClick(){
		console.log('I got clicked, go me!')
	},

	/////////////////
	// Typography //
	/////////////////

	_renderTypography() {
		return(
			<Container justifyContent="center" margin={true} flexDirection="row">
				<Block width="800px">
					<Paper depth={1} overflow={false}>
						<StickyHeader status="secondary" width="800px" height="600px">
							<Header title="Vertical Rhythm" padded={false}>
								{this._getVerticalRhythmExample()}
							</Header>

						</StickyHeader>
					</Paper>
				</Block>
			</Container>
		);
	},

	_getVerticalRhythmExample() {
		var code =
			'<h1>h1. Html Heading</h1>\n' +
			'<h2>h2. Html Heading</h2>\n' +
			'<h1>h1. Html Heading</h1>\n' +
			'<h2>h2. Html Heading</h2>\n' +
			'<h3>h3. Html Heading</h3>\n' +
			'<h4>h4. Html Heading</h4>\n' +
			'<h5>h5. Html Heading</h5>\n' +
			'<h6>h6. Html Heading</h6>\n' +
			'<p>\n' +
			'  p. Lorem ipsum dolor sit amet, sed docendi suscipit scripserit eu, persius invenire\n' +
			'  id sea. Ius dicant facilis propriae an, ut vim nonumy meliore lucilius, usu nonumes\n' +
			'  phaedrum ad. Ea nam error audiam, oratio nostrud pro id. Ut sea cetero labitur\n' +
			'  gubergren, munere maiorum nostrum vim ut, te feugiat vulputate cum. Choro volumus\n' +
			'  sapientem te sed, legimus splendide ad nec.\n' +
			'</p>\n';

		return (
			<Container flexDirection="column" justifyContent="center">
				<Paper depth={1}>
					<Block width={1}  padded={true}>
						<div>
							<h1>h1. Html Heading</h1>
							<h2>h2. Html Heading</h2>
							<h3>h3. Html Heading</h3>
							<h4>h4. Html Heading</h4>
							<h5>h5. Html Heading</h5>
							<h6>h6. Html Heading</h6>
							<p>p. Lorem ipsum dolor sit amet, sed docendi suscipit scripserit eu, persius invenire id sea. Ius dicant facilis propriae an, ut vim nonumy meliore lucilius, usu nonumes phaedrum ad. Ea nam error audiam, oratio nostrud pro id. Ut sea cetero labitur gubergren, munere maiorum nostrum vim ut, te feugiat vulputate cum. Choro volumus sapientem te sed, legimus splendide ad nec.</p>
						</div>
					</Block>
					<Block width={1}>
						<CodeBlock>
							{code}
						</CodeBlock>
					</Block>
				</Paper>
			</Container>
		);
	},

	_getScaleExample() {
		var code =
		'<div className="lui-font-style-display-4">Light 112px</div>\n' +
		'<div className="lui-font-style-display-3">Regular 56px</div>\n' +
		'<div className="lui-font-style-display-2">Regular 45px</div>\n' +
		'<div className="lui-font-style-display-1">Regular 34px</div>\n' +
		'<div className="lui-font-style-headline">Regular 24px</div>\n' +
		'<div className="lui-font-style-toolbar">Medium 20px</div>\n' +
		'<div className="lui-font-style-title">Medium 20px</div>\n' +
		'<div className="lui-font-style-subhead-1">Regular 15px</div>\n' +
		'<div className="lui-font-style-body-2">Medium 13px</div>\n' +
		'<div className="lui-font-style-body-1">Regular 13px</div>\n' +
		'<div className="lui-font-style-caption">Regular 12px</div>\n' +
		'<div className="lui-font-style-menu">Medium 13px</div>\n' +
		'<div className="lui-font-style-button">MEDIUM (ALL CAPS) 14px</div>';

		return (
			<Container flexDirection="column" justifyContent="center">
				<Paper depth={1}>
					<Block width={1} padded={true}>
						<div className="lui-font-style-display-4">Light 112px</div>
						<div className="lui-font-style-display-3">Regular 56px</div>
						<div className="lui-font-style-display-2">Regular 45px</div>
						<div className="lui-font-style-display-1">Regular 34px</div>
						<div className="lui-font-style-headline">Regular 24px</div>
						<div className="lui-font-style-toolbar">Medium 20px</div>
						<div className="lui-font-style-title">Medium 20px</div>
						<div className="lui-font-style-subhead-1">Regular 15px</div>
						<div className="lui-font-style-body-2">Medium 13px</div>
						<div className="lui-font-style-body-1">Regular 13px</div>
						<div className="lui-font-style-caption">Regular 12px</div>
						<div className="lui-font-style-menu">Medium 13px</div>
						<div className="lui-font-style-button">MEDIUM (ALL CAPS) 14px</div>
					</Block>
					<Block width={1}>
						<CodeBlock>
							{code}
						</CodeBlock>
					</Block>
				</Paper>
			</Container>
		);
	},

	_getColorExample() {
		var code =
			'<div className="lui-font-style-display-4">Black 54%</div>\n' +
			'<div className="lui-font-style-display-3">Black 54%</div>\n' +
			'<div className="lui-font-style-display-2">Black 54%</div>\n' +
			'<div className="lui-font-style-display-1">Black 54%</div>\n' +
			'<div className="lui-font-style-headline">Black 87%</div>\n' +
			'<div className="lui-font-style-toolbar">Black 87%</div>\n' +
			'<div className="lui-font-style-title">Black 87%</div>\n' +
			'<div className="lui-font-style-subhead-1">Black 87%</div>\n' +
			'<div className="lui-font-style-body-2">Black 87%</div>\n' +
			'<div className="lui-font-style-body-1">Black 87%</div>\n' +
			'<div className="lui-font-style-caption">Black 54%</div>\n' +
			'<div className="lui-font-style-menu">Black 87%</div>\n' +
			'<div className="lui-font-style-button">Black 87%</div>';

		return (
			<Container flexDirection="column" justifyContent="center">
				<Paper depth={1}>
					<Block width={1} padded={true}>
						<div className="lui-font-style-display-4">Black 54%</div>
						<div className="lui-font-style-display-3">Black 54%</div>
						<div className="lui-font-style-display-2">Black 54%</div>
						<div className="lui-font-style-display-1">Black 54%</div>
						<div className="lui-font-style-headline">Black 87%</div>
						<div className="lui-font-style-toolbar">Black 87%</div>
						<div className="lui-font-style-title">Black 87%</div>
						<div className="lui-font-style-subhead-1">Black 87%</div>
						<div className="lui-font-style-body-2">Black 87%</div>
						<div className="lui-font-style-body-1">Black 87%</div>
						<div className="lui-font-style-caption">Black 54%</div>
						<div className="lui-font-style-menu">Black 87%</div>
						<div className="lui-font-style-button">Black 87%</div>
					</Block>
					<Block width={1}>
						<CodeBlock>
							{code}
						</CodeBlock>
					</Block>
				</Paper>
			</Container>
		);
	},

	_getTrackingExample() {

		var code =
			'<div className="lui-font-style-display-4">Tracking -10px</div>\n' +
			'<div className="lui-font-style-display-3">Tracking -5px</div>\n' +
			'<div className="lui-font-style-display-2">Tracking 0px</div>\n' +
			'<div className="lui-font-style-display-1">Tracking 0px</div>\n' +
			'<div className="lui-font-style-toolbar">Tracking 0px</div>\n' +
			'<div className="lui-font-style-headline">Tracking 0px</div>\n' +
			'<div className="lui-font-style-title">Tracking 5px</div>\n' +
			'<div className="lui-font-style-subhead-1">Tracking 10px</div>\n' +
			'<div className="lui-font-style-body-2">Tracking 10px</div>\n' +
			'<div className="lui-font-style-body-1">Tracking 10px</div>\n' +
			'<div className="lui-font-style-caption">Tracking 20px</div>\n' +
			'<div className="lui-font-style-menu">Tracking 10px</div>\n' +
			'<div className="lui-font-style-button">Tracking 10px</div>\n';

		return (
			<Container flexDirection="column" justifyContent="center">
				<Block width={1}>
					<Paper depth={1} padded={true}>
						<div className="lui-font-style-display-4">Tracking -10px</div>
						<div className="lui-font-style-display-3">Tracking -5px</div>
						<div className="lui-font-style-display-2">Tracking 0px</div>
						<div className="lui-font-style-display-1">Tracking 0px</div>
						<div className="lui-font-style-toolbar">Tracking 0px</div>
						<div className="lui-font-style-headline">Tracking 0px</div>
						<div className="lui-font-style-title">Tracking 5px</div>
						<div className="lui-font-style-subhead-1">Tracking 10px</div>
						<div className="lui-font-style-body-2">Tracking 10px</div>
						<div className="lui-font-style-body-1">Tracking 10px</div>
						<div className="lui-font-style-caption">Tracking 20px</div>
						<div className="lui-font-style-menu">Tracking 10px</div>
						<div className="lui-font-style-button">Tracking 10px</div>
					</Paper>
				</Block>
				<Block width={1}>
					<Paper depth={1}>
						<CodeBlock>
							{code}
						</CodeBlock>
					</Paper>
				</Block>
			</Container>
		);
	},

	/////////////
	// Devider //
	/////////////

	_renderDivider() {
		return (
			<Container margin={true} flexDirection="row">
				<Block width="700px">
					<Paper depth={1} overflow={false}>
						<Block padded={true}>
							<div>
								<span className="lui-font-style-subhead-1">Sandra: </span>
								<span className="lui-font-style-menu">Do you like my 10px left and right indented divider component with a spicy bevel?</span>
								<span className="lui-font-style-caption"> 11:42pm</span>
							</div>
						</Block>
						<Divider bevel={true} offsetLeft={10} offsetRight={10} />
						<Block padded={true}>
							<div>
								<span className="lui-font-style-subhead-1">You: </span>
								<span className="lui-font-style-menu">OMG I friggin love it, you dig this full width one?</span>
								<span className="lui-font-style-caption"> 11:45pm</span>
							</div>
						</Block>
						<Divider bevel={false} offsetLeft={0} offsetRight={0} />
						<Block padded={true}>
							<div>
								<span className="lui-font-style-subhead-1">Sandra: </span>
								<span className="lui-font-style-menu">It spits hot fire</span>
								<span className="lui-font-style-caption"> 11:49pm</span>
							</div>
						</Block>
					</Paper>
				</Block>
			</Container>
		)
	},

	////////////
	// Paper //
	////////////

	_renderPaper() {

		let content = 'Lorem ipsum Nostrud irure occaecat nulla in deserunt commodo sunt sit exercitation cupidatat cupidatat esse aliquip irure non.';

		return (
			<div>
				<Container margin={true} flexDirection="row">
					<Block margin={true} width={2}>
						<Container flexDirection="column">
							<Paper padded={false} depth={0}>
								<Block padded={true}>
									{content}
								</Block>
								<Block padded={false}>
									<CodeBlock>
										{'<Paper padded={true} depth={0}>{content}</Paper>'}
									</CodeBlock>
								</Block>
							</Paper>
						</Container>
					</Block>
					<Block margin={true} width={2}>
						<Container flexDirection="column">
							<Paper padded={false} depth={1}>
								<Block padded={true}>
									{content}
								</Block>
								<Block padded={false}>
									<CodeBlock>
										{'<Paper padded={true} depth={1}>{content}</Paper>'}
									</CodeBlock>
								</Block>
							</Paper>
						</Container>
					</Block>
					<Block margin={true} width={2}>
						<Container flexDirection="column">
							<Paper padded={false} depth={2}>
								<Block padded={true}>
									{content}
								</Block>
								<Block padded={false}>
									<CodeBlock>
										{'<Paper padded={true} depth={2}>{content}</Paper>'}
									</CodeBlock>
								</Block>
							</Paper>
						</Container>
					</Block>
				</Container>
				<Container margin={true} flexDirection="row">
					<Block margin={true} width={2}>
						<Container flexDirection="column">
							<Paper padded={false} depth={3}>
								<Block padded={true}>
									{content}
								</Block>
								<Block padded={false}>
									<CodeBlock>
										{'<Paper padded={true} depth={3}>{content}</Paper>'}
									</CodeBlock>
								</Block>
							</Paper>
						</Container>
					</Block>
					<Block margin={true} width={2}>
						<Container flexDirection="column">
							<Paper padded={false} depth={4}>
								<Block padded={true}>
									{content}
								</Block>
								<Block padded={false}>
									<CodeBlock>
										{'<Paper padded={true} depth={4}>{content}</Paper>'}
									</CodeBlock>
								</Block>
							</Paper>
						</Container>
					</Block>
					<Block margin={true} width={2}>
						<Container flexDirection="column">
							<Paper padded={false} depth={5}>
								<Block padded={true}>
									{content}
								</Block>
								<Block padded={false}>
									<CodeBlock>
										{'<Paper padded={true} depth={5}>{content}</Paper>'}
									</CodeBlock>
								</Block>
							</Paper>
						</Container>
					</Block>
				</Container>
			</div>
		);
	},

	_renderFontIcon() {
		return(
			<Container margin={true} flexDirection="row" alignItems="stretch">

				<Block width={1} margin={true}>
					<FontIcon icon="flask" />
					<p>Normal</p>
				</Block>

				<Block width={1} margin={true}>
					<FontIcon icon="flask" magnify={2} />
					<p>Magnify 2x</p>
				</Block>

				<Block width={1} margin={true}>
					<FontIcon icon="flask" magnify={3} />
					<p>Magnify 3x</p>
				</Block>

				<Block width={1} margin={true}>
					<FontIcon icon="flask" magnify={4} />
					<p>Magnify 4x</p>
				</Block>

				<Block width={1} margin={true}>
					<FontIcon icon="flask" magnify={5} />
					<p>Magnify 5x</p>
				</Block>
			</Container>
		)
	},

	_getFontTools() {
		return(
			<span>
				<IconButton icon="pencil" tooltip="edit" />
				<IconButton icon="plus" tooltip="THIS IS A REALLY LONG AND BIG TOOLTIP MESSAGE TO TEST OUT TOOLTIP ANIMATIONS, THIS IS ONLY A TEST, IF THIS HAD BEEN A REAL TOOLTIP, IT WOULD BE STUPID." />
				<IconButton icon="times" tooltip="delete" disabled={true}/>
			</span>
		);
	},

	//////////////
	// Buttons //
	//////////////

	_renderButtons() {
		let menuItems = [
		   { payload: '1', text: 'Never' },
		   { payload: '2', text: 'Every Night' },
		   { payload: '3', text: 'Weeknights' },
		   { payload: '4', text: 'Weekends' },
		   { payload: '5', text: 'Weekly' },
		];

		return (
			<div>
				<Container margin={true} flexDirection="row" justifyContent="center">
					<Block width={1} padded={true}>
						<FlatButton label="Flat Button Primary" global={true} status="primary" href="http://www.google.com" target="_blank" disabled={true}/>
					</Block>
					<Block width={1} padded={true}>
						<FlatButton label="Flat Button Secondary" status="secondary" />
					</Block>
					<Block width={1} padded={true}>
						<FlatButton label="Flat Button Success" status="success" />
					</Block>
					<Block width={1} padded={true}>
						<FlatButton label="Flat Button Alert" status="alert" />
					</Block>
					<Block width={1} padded={true}>
						<FlatButton label="Flat Button Error" status="error" />
					</Block>
				</Container>
				<Container margin={true} flexDirection="row" justifyContent="center">
					<Block width={1} padded={true}>
						<RaisedButton label="Raised Button Primary" href="http://www.google.com" status="primary" disabled={true} />
					</Block>
					<Block width={1} padded={true}>
						<RaisedButton label="Raised Button Secondary" status="secondary" href='/colors' poopser={true}/>
					</Block>
					<Block width={1} padded={true}>
						<RaisedButton label="Raised Button Success" status="success" />
					</Block>
					<Block width={1} padded={true}>
						<RaisedButton label="Raised Button Alert" status="alert" />
					</Block>
					<Block width={1} padded={true}>
						<RaisedButton label="Raised Button Error" status="error" />
					</Block>
				</Container>
				<Container margin={true} flexDirection="row" justifyContent="center">
					<Block width={1} padded={true}>
						<FlatSplitButton label="Flat Split Btn Primary" status="primary" rounded={true} menuItems={menuItems} disabled={true} />
					</Block>
					<Block width={1} padded={true}>
						<FlatSplitButton label="Flat Split Btn Secondary" status="secondary" rounded={true} menuItems={menuItems} />
					</Block>
					<Block width={1} padded={true}>
						<FlatSplitButton label="Flat Split Btn Success" status="success" rounded={true} menuItems={menuItems} />
					</Block>
					<Block width={1} padded={true}>
						<FlatSplitButton label="Flat Split Btn Alert" status="alert" rounded={true} menuItems={menuItems} />
					</Block>
					<Block width={1} padded={true}>
						<FlatSplitButton label="Flat Split Btn Error" status="error" rounded={true} menuItems={menuItems} />
					</Block>

				</Container>
				<Container margin={true} flexDirection="row" justifyContent="center">
					<Block width={1} padded={true}>
						<RaisedSplitButton label="Raised Split Btn Primary" status="primary" rounded={true} menuItems={menuItems} disabled={true} />
					</Block>
					<Block width={1} padded={true}>
						<RaisedSplitButton label="Raised Split Btn Secondary" status="secondary" rounded={true} menuItems={menuItems} />
					</Block>
					<Block width={1} padded={true}>
						<RaisedSplitButton label="Raised Split Btn Success" status="success" rounded={true} menuItems={menuItems} />
					</Block>
					<Block width={1} padded={true}>
						<RaisedSplitButton label="Raised Split Btn Alert" status="alert" rounded={true} menuItems={menuItems} />
					</Block>
					<Block width={1} padded={true}>
						<RaisedSplitButton label="Raised Split Btn Error" status="error" rounded={true} menuItems={menuItems} />
					</Block>

				</Container>
				{this._renderIconButtons()}
			</div>
		)
	},

	_renderIconButtons() {

		return(
			<span>
				<IconButton icon="pencil" tooltip="edit" to='/home' />
				<IconButton icon="plus" tooltip="Big long tooltip text" />
				<IconButton icon="trash" tooltip="delete" disabled={true} />
			</span>

		);

	},

	_renderLorem() {
		return (
			<div>
				<p>"Lorem ipsum Sed dolore nisi dolor pariatur aliqua officia sed veniam dolor velit officia nulla eu in fugiat in Duis proident ullamco id ex pariatur in dolore consectetur amet deserunt quis ut id fugiat magna veniam ut incididunt veniam qui eu ex aliquip magna mollit non deserunt officia dolor nulla consequat Duis sint velit nulla aliqua Duis ea nostrud in dolor incididunt mollit sunt enim Ut aliquip qui nisi fugiat in do qui irure dolore labore nulla enim dolore tempor esse proident et proident proident in consectetur nisi velit dolore ullamco amet minim culpa dolor aute ullamco quis in elit velit culpa voluptate nostrud do dolore eiusmod nisi sint occaecat esse ea do irure dolor magna voluptate in quis nisi occaecat incididunt sed dolore ut officia ut tempor occaecat esse exercitation veniam est mollit Ut veniam cupidatat ea irure sit deserunt consequat minim Excepteur fugiat amet Duis in qui voluptate aliquip eu eu dolor ex minim cillum qui nostrud enim ut dolor ullamco officia laboris dolore ad est aliquip laboris incididunt nulla ullamco dolor est veniam est deserunt nostrud amet ut sit esse voluptate ex dolore nulla tempor occaecat qui consequat laboris nulla sunt quis reprehenderit veniam esse adipisicing irure velit ut voluptate."</p>
			</div>
		);
	},

	_renderStickyHeader() {

		return(
			<Container justifyContent="center" margin={true} flexDirection="row">
				<Block margin={true} width="800px">
					<Paper padded={false} depth={1} overflow={false}>
						<StickyHeader width="800px" height="400px" status="secondary">
							<Header title="1" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="2">
								{this._renderLorem()}
							</Header>
							<Header title="3" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="4" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="5" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="6" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="7" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="8" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="9" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="10" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="11" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="12" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="13" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="14" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="15" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="16" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="17" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="18" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="19" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="20" tools={this._getFontTools()}>
								{this._renderLorem()}
								{this._renderLorem()}
								{this._renderLorem()}
								{this._renderLorem()}
								{this._renderLorem()}
								{this._renderLorem()}
								{this._renderLorem()}
							</Header>
							<Header title="21" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="22" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="23" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="24" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="25" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="26" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="27" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="28" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
							<Header title="29" tools={this._getFontTools()}>
								{this._renderLorem()}
							</Header>
						</StickyHeader>
					</Paper>
				</Block>
			</Container>

		);
	},

	_renderList() {
		return (
			<Container margin={true} flexDirection="row" justifyContent="center">
				<Block width={1} margin={true}>
					<Paper padded={false} depth={1}>
						<ListContainer direction="column" divided={true}>
							<ListItem meta={["apple",'orange']} direction="row" image="http://www.w3schools.com/html/html5.gif">
								<p> I am a ListItem with an image, I look really good.</p>
							</ListItem>
							<ListItem meta={{id: "apple", user: 'orange'}} direction="row" fontIcon="btc">
								<p> I am a ListItem with a FontIcon, I look really good.</p>
							</ListItem>
							<ListItem direction="row" fontIconClass="custom-class" fontIcon="power-off">
								<p> I am a ListItem with a FontIcon with a custom fontIconClass, I look really good.</p>
							</ListItem>
							<ListItem direction="row" fontIconClass="custom-class" fontIcon="users" image="http://www.w3schools.com/html/html5.gif">
								<p> I am a ListItem with a FontIcon, a custom fontIconClass, and an image.</p>
							</ListItem>
							<ListItem
								direction="row"
								slideButton="chevron-left"
								slideDirection="right"
								slideAmount="55%"
								slideContent="I am some fancy pants slide content!"
								expandButton="chevron-down"
								expandDirection="down"
								expandeButtonSide="left"
								expandAmount={400}
								expandContent="I am some EVEN FANCIER content!">
								 I am a ListItem with a slideButton, sliding right.
							</ListItem>
							<ListItem
								direction="row"
								slideButton="chevron-right"
								slideDirection="left"
								slideAmount={400}
								slideContent="I am some EVEN FANCIER content!"
								disabled={true}>
								 I am a ListItem with a slideButton, sliding left.
							</ListItem>
							<ListItem
								direction="row"
								slideButton="chevron-right"
								slideDirection="left"
								slideAmount={400}
								slideContent="I am some EVEN FANCIER content!"
								expandButton="chevron-up"
								expandDirection="up"
								expandAmount={400}
								expandContent="I am some EVEN FANCIER content!">
								 I am a ListItem with a slideButton, sliding left.
							</ListItem>
						</ListContainer>
					</Paper>
				</Block>
				<Block width={1} margin={true}>
					<Paper padded={false} depth={1}>
						<ListContainer direction="column" filter="apple">
							<ListItem direction="column" meta={{id: "apple", user: 'orange'}} image="http://www.w3schools.com/html/html5.gif">
								<p> I am a ListItem with an image, I look really good.</p>
							</ListItem>
							<ListItem direction="column" fontIcon="btc">
								<p> I am a ListItem with a FontIcon, I look really good.</p>
							</ListItem>
							<ListItem direction="column" fontIconClass="custom-class" fontIcon="power-off">
								<p> I am a ListItem with a FontIcon with a custom fontIconClass, I look really good.</p>
							</ListItem>
							<ListItem direction="column" image="http://www.w3schools.com/html/html5.gif" fontIconClass="custom-class" fontIcon="users">
								<p> I am a ListItem with a FontIcon, a custom fontIconClass, and an image.</p>
							</ListItem>
						</ListContainer>
					</Paper>
				</Block>
				<Block width={1} margin={true}>
					<Paper padded={false} depth={1}>
						<ListContainer direction="row">
							<ListItem maxWidth="150px" direction="column" image="http://www.w3schools.com/html/html5.gif">
								<p> I am a ListItem with an image, I look really good.</p>
							</ListItem>
							<ListItem maxWidth="150px" direction="column" fontIcon="btc">
								<p> I am a ListItem with a FontIcon, I look really good.</p>
							</ListItem>
							<ListItem maxWidth="150px" direction="column" fontIconClass="custom-class" fontIcon="power-off">
								<p> I am a ListItem with a FontIcon with a custom fontIconClass, I look really good.</p>
							</ListItem>
							<ListItem maxWidth="150px" direction="column" image="http://www.w3schools.com/html/html5.gif" fontIconClass="custom-class" fontIcon="users">
								<p> I am a ListItem with a FontIcon, a custom fontIconClass, and an image.</p>
							</ListItem>
						</ListContainer>
					</Paper>
				</Block>
			</Container>
		)
	},


	/////////////////
	// Fancy Card //
	/////////////////

	_renderFancyCard() {

		let customHeader = [
			<Container key={1} flexDirection="row" height="100%">
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								CPU
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								23%
							</div>
						</Block>
					</Container>
				</Block>
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								RAM
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								5432/16000 MB
							</div>
						</Block>
					</Container>
				</Block>
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								I/O
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								22.4%
							</div>
						</Block>
					</Container>
				</Block>
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								NETWORK
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								4323 Kbps
							</div>
						</Block>
					</Container>
				</Block>
			</Container>
		];

		return (
			<Container margin={true} flexDirection="row" justifyContent="center">
				<Block width={1} margin={true}>
					<FancyCard
						headerTitle="I am a FancyCard title."
						headerSubtitle="I am a FancyCard subtitle."
						headerStatus="primary"
						headerStatusBarText="I am a FancyCard status bar."
						transitionDirection="up"
						ref="fancyCard"  >

						{this._renderLorem()}
						<Container width={1}>
							<Block>
								<FlatButton status="secondary" onClick={this._fancyCardChangeHeaderText.bind(this, 1)}>
									Change Header Text One
								</FlatButton>
							</Block>
							<Block>
								<FlatButton status="secondary" onClick={this._fancyCardChangeHeaderText}>
									Change Header Text Two
								</FlatButton>
							</Block>
						</Container>
					</FancyCard>
				</Block>
				<Block width={1} margin={true}>
					<FancyCard
						customHeader={customHeader}
						headerStatus="primary"
						headerStatusBarText="I am a FancyCard status bar."
						transitionDirection="up"
						ref="fancyCardCustom"  >

						{this._renderLorem()}
						<Container width={1}>
							<Block>
								<FlatButton status="secondary" onClick={this._fancyCardChangeCustomHeader.bind(this, 1)}>
									Change Header Text One
								</FlatButton>
							</Block>
							<Block>
								<FlatButton status="secondary" onClick={this._fancyCardChangeCustomHeader}>
									Change Header Text Two
								</FlatButton>
							</Block>
						</Container>
					</FancyCard>
				</Block>
			</Container>
		)
	},


	_getFancyCardTools() {

		return(
			<span>
				<IconButton onClick={this._fancyCardToggleStatusBar} icon="dot-circle-o" tooltip="Status Bar" />
				<IconButton onClick={this._fancyCardHeaderStateWarning} icon="exclamation-triangle" tooltip="Warning State" />
				<IconButton onClick={this._fancyCardHeaderStateSuccess} icon="thumbs-up" tooltip="Success State" />
				<IconButton onClick={this._fancyCardHeaderStatePrimary} icon="circle" tooltip="Primary State" />
			</span>
		);

	},

	_fancyCardToggleStatusBar(ref) {

		if(ref.type === "click") {
			this.refs.fancyCard.toggleHeaderStatusBar();
			this.refs.fancyCardCustom.toggleHeaderStatusBar();
		} else {
			ref = eval(ref);
			ref.toggleHeaderStatusBar();
		}

	},

	_fancyCardHeaderStateSuccess(ref) {
		this.refs.fancyCard.setHeaderStatus('success');
		this.refs.fancyCardCustom.setHeaderStatus('success');
	},

	_fancyCardHeaderStateWarning(ref) {
		this.refs.fancyCard.setHeaderStatus('warning');
		this.refs.fancyCardCustom.setHeaderStatus('warning');
	},

	_fancyCardHeaderStatePrimary(ref) {
		this.refs.fancyCard.setHeaderStatus('primary');
		this.refs.fancyCardCustom.setHeaderStatus('primary');
	},

	_fancyCardChangeHeaderText(option) {

		console.log('I got klicked')

		if (option === 1){
			this.refs.fancyCard.setState({
				headerTitle: 'Wasn\'t that transition nice?',
				headerSubtitle: 'Yes FancyCard, yes it was.',
			});
		} else {
			this.refs.fancyCard.setState({
				headerTitle: 'That transition was even nicer!',
				headerSubtitle: 'Now, you are just bragging FancyCard.',
			});
		}
	},

	_fancyCardChangeCustomHeader(option) {

		let newCustomHeader = [
			<Container key={2} flexDirection="row" height="100%">
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								CLICKS
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								423432
							</div>
						</Block>
					</Container>
				</Block>
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								VISITORS
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								12,032
							</div>
						</Block>
					</Container>
				</Block>
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								NEW VISITORS
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								2,312
							</div>
						</Block>
					</Container>
				</Block>
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								TREND
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								+23%
							</div>
						</Block>
					</Container>
				</Block>
			</Container>
		];

		let altCustomHeader = [
			<Container key={1} flexDirection="row" height="100%">
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								CPU
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								23%
							</div>
						</Block>
					</Container>
				</Block>
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								RAM
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								5432/16000 MB
							</div>
						</Block>
					</Container>
				</Block>
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								I/O
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								22.4%
							</div>
						</Block>
					</Container>
				</Block>
				<Block width={1} padded={false}>
					<Container key={1} flexDirection="column">
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-title lui-font-style-headline">
								NETWORK
							</div>
						</Block>
						<Block width={1} padded={false}>
							<div key={1} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
								4323 Kbps
							</div>
						</Block>
					</Container>
				</Block>
			</Container>
		];


		if (option === 1){
			this.refs.fancyCardCustom.setState({
				customHeader: newCustomHeader
			});
		} else {
			this.refs.fancyCardCustom.setState({
				customHeader: altCustomHeader
			});
		}
	},

	_renderDialog() {

		var actions = [
			{ text: 'Cancel' , key: 1 },
			{ text: 'Submit', key: 2},
			{ text: 'Stop Drop, and Roll', key: 3}
		];

		var originDialogTrigger = {
			type: 'button',
			text: 'Open Dialog',
			status: 'secondary',
			key: 1
		};

		var dialogTrigger = {
			type: 'button',
			text: 'Open Dialog From Origin',
			status: 'secondary'
		};


		return (
		<Container key={1} flexDirection="row" alignItems="flex-start" justifyContent="center" >
			<Block width={'250px'} padded={true}>
				<Dialog animateFromOrigin={true} actions={actions} ref="dialog" trigger={dialogTrigger} title="This here be an excellent dialog.">
						In the beginning, there was a DIALOG, and it was good.
				</Dialog>
			</Block>
			<Block width={'250px'} padded={true}>
				<Dialog animateFromOrigin={false} actions={actions} ref="dialog" trigger={originDialogTrigger} title="This here be an excellent dialog.">
						In the beginning, there was a DIALOG, and it was good.
				</Dialog>
			</Block>
			<Block width={'250px'} padded={true}>
				<Dialog animateFromOrigin={false} actions={actions} ref="dialogCustom" title="This here be an excellent dialog.">
						In the beginning, there was a DIALOG, and it was good.
				</Dialog>
				<FlatButton onClick={this._triggerDialog} status="secondary" label="Trigger Dialog With Ref"/>
			</Block>
		</Container>
		);
	},

	_triggerDialog() {
		this.refs.dialogCustom.show();
	},

	_renderCharts() {

		var data = {
			BarChart: [4, 8, 15, 16, 23, 42]
		}

		return (
			<div>
				<div>
					<Charts.BarChart
						data={data.BarChart}
						direction="horizontal">
					</Charts.BarChart>
				</div>
				<div>
					<Charts.BarChart
						data={data.BarChart}
						direction="vertical">
					</Charts.BarChart>
				</div>
				<div>
					<Charts.Chord>
					</Charts.Chord>
				</div>
				<div>
					<Charts.Donut>
					</Charts.Donut>
				</div>
				<div>
					<Charts.Heatmap>
					</Charts.Heatmap>
				</div>
				<div>
					<Charts.Highrise>
					</Charts.Highrise>
				</div>
				<div>
					<Charts.Multiline>
					</Charts.Multiline>
				</div>
				<div>
					<Charts.RadialClock>
					</Charts.RadialClock>
				</div>
				<div>
					<Charts.SparkBar>
					</Charts.SparkBar>
				</div>
				<div>
					<Charts.SparkLine>
					</Charts.SparkLine>
				</div>
			</div>
		);
	},

	////////////
	// Forms //
	////////////

	_renderForms() {
		return (
			<div>
				<Container key={1} flexDirection="row" alignItems="flex-start" justifyContent="center" >
					<Block width={1} margin={true} >
						<TextField
							hintText="Hint Text" />
					</Block>
					<Block width={1} margin={true} >
						<TextField
							hintText="Hint Text"
							floatingLabelText="Floating Label Text" />
					</Block>
					<Block width={1} margin={true} >
						<TextField
						  hintText="Disabled Hint Text"
						  ref="disabledTextField"
						  disabled={this.state.toggleDisable}
						  floatingLabelText="Floating Label Text" />
					</Block>
					<Block width={1} margin={true} >
						<TextField
							onChange={this._setErrorText}
							onFocus={this._setErrorText}
							ref="errorTextField"
							hintText="There's something erroring here."
							floatingLabelText="Important Things" />

					</Block>
				</Container>
				<Container margin={true} key={2} flexDirection="row" alignItems="center" justifyContent="center" >
					<Block width={1} margin={true}>
						<RadioGroup
							name="shipSpeed"
							ref="derpspeed"
							defaultSelected="not_light"
							onChange={this._testCheck}>
							<Container margin={true} key={2} flexDirection="row" alignItems="center" justifyContent="center" >
								<Block>
									<Radio
										value="light"
										label="prepare for light speed"
										onCheck={this._testCheck} />
								</Block>
								<Block>
									<Radio
										value="not_light"
										label="light speed too slow"
										defaultChecked={true} />
								</Block>
							</Container>
							<Radio
								value="ludicrous"
								label="go to ludicous speed"
								disabled={true}/>
						</RadioGroup>
					</Block>
					<Block width={1} margin={true}>
						<Toggle
						  name="toggleName1"
						  value="toggleValue1"
						  label="activate thrusters" />
						<Toggle
						  onToggle={this._handleToggle}
						  name="toggleName2"
						  value="toggleValue2"
						  label="activate thrusters" />
						<Toggle
						  onToggle={this._handleToggle}
						  name="toggleName3"
						  value="toggleValue3"
						  label="Toggle Disable" />
						<Toggle
						  name="toggleName4"
						  value="toggleValue4"
						  label="disabled"
						  disabled={true} />

					</Block>
					<Block width={1} margin={true}>
						<Checkbox
						  name="checkboxName1"
						  value="checkboxValue1"
						  label="I'm a primary checkbox look at me!"
						  status="primary" />
						<Checkbox
						  name="checkboxName2"
						  value="checkboxValue2"
						  status="success"
						  label="Can do!"
						  defaultSwitched={true} />
						<Checkbox
						  name="checkboxName3"
						  value="checkboxValue3"
						  status="disabled"
						  label="Disabled checked"
						  defaultSwitched={true}
						  disabled={true} />
					</Block>
					<Block width={1} margin={true}>

					</Block>
				</Container>
				<Container margin={true} key={3} flexDirection="row" alignItems="center" justifyContent="center" >
					<Block width={1}>
						<Autocomplete
							ref="autocomplete"
							defaultLabel="three"
							hintText='Pick a number one to ten'
							focusPlaceholder='Press DOWN to see all options'
							onDismiss={this._testCheck}
							options={[
								{ label: 'one', value: '1'},
								{ label: 'two', value: '2'},
								{ label: 'three', value: '3'},
								{ label: 'four', value: '4'},
								{ label: 'five', value: '5'},
								{ label: 'six', value: '6'},
								{ label: 'seven', value: '7'},
								{ label: 'eight', value: '8'},
								{ label: 'nine', value: '9'},
								{ label: 'ten', value: '10'},

							]}
							maxVisible={5}
							status="primary"/>

					</Block>
					<Block width={1} margin={true}>
						<Autocomplete
							ref="autocomplete"
							hintText='Pick a number one to ten'
							focusPlaceholder='Press DOWN to see all options'
							options={[
								{ label: 'one', value: '1'},
								{ label: 'two', value: '2'},
								{ label: 'three', value: '3'},
								{ label: 'four', value: '4'},
								{ label: 'five', value: '5'},
								{ label: 'six', value: '6'},
								{ label: 'seven', value: '7'},
								{ label: 'eight', value: '8'},
								{ label: 'nine', value: '9'},
								{ label: 'ten', value: '10'},
							]}
							optionValidate={true}
							maxVisible={5}
							status="success" />

					</Block>
					<Block width={1} margin={true}>
						<Autocomplete
							ref="autocomplete"
							hintText='Pick a number one to ten'
							focusPlaceholder='Press DOWN to see all options'
							floatingLabelText='Awww yiss'
							options={[
								{ label: 'one', value: '1'},
								{ label: 'two', value: '2'},
								{ label: 'three', value: '3'},
								{ label: 'four', value: '4'},
								{ label: 'five', value: '5'},
								{ label: 'six', value: '6'},
								{ label: 'seven', value: '7'},
								{ label: 'eight', value: '8'},
								{ label: 'nine', value: '9'},
								{ label: 'ten', value: '10'},
							]}
							maxVisible={5}
							status="primary"
							isSelect={true}/>

					</Block>
				</Container>
			</div>
		);
	},

	_handleSelectRequired() {
		let node = this.refs.autocomplete;
		let visibleOptions = node.getOptionsForValue(node.getValue(), node.props.options);
		console.log(visibleOptions)

		if (visibleOptions.length) {
			node.setStatus('success');
			node.setSubText('');
			return;
		} else {
			node.setStatus('error');
			node.setSubText('You must select a valid option.');
			return;
		}
	},

	_handleToggle(){
		this.setState({
			toggleDisable: !this.state.toggleDisable
		});
	},

	_setErrorText(){
		if (this.refs.errorTextField.getValue()){
			this.refs.errorTextField.setErrorText(null);
		} else {
			this.refs.errorTextField.setErrorText('This field is required');
		}
	},

	_testCheck() {
		console.log('here');
	},

	///////////////
	// Snackbar //
	///////////////

	_renderSnackbarTrigger() {
		return (
			<Container>
				<Block>
					<FlatButton onClick={this._triggerSnackbarPrimary} status="secondary" label="Trigger Snackbar Primary"/>
					<Snackbar
						ref="snackbarPrimary"
						message="Something happened you should know aboutSomething happened you should know aboutSomething happened you should know aboutSomething happened you should know aboutSomething happened you should know about"
						action="dismiss"
						onActionTouchTap={this._dismissSnackbar}
						status="primary" />
				</Block>
				<Block>
					<FlatButton onClick={this._triggerSnackbarSuccess} status="secondary" label="Trigger Snackbar Success"/>
					<Snackbar
						ref="snackbarSuccess"
						message="Something happened you should know about"
						action="dismiss"
						onActionTouchTap={this._dismissSnackbar}
						status="success" />
				</Block>
			</Container>
		);
	},

	_triggerSnackbarPrimary() {
		this.refs.snackbarPrimary.show();
	},

	_triggerSnackbarSuccess() {
		this.refs.snackbarSuccess.show();
	},

	_dismissSnackbar() {
		this.refs.snackbarPrimary.dismiss();
		this.refs.snackbarSuccess.dismiss();
	},

	/////////////////
	// DatePicker //
	/////////////////

	_renderDatePicker() {
		let timeOffset = [
			{name: 'NY4', offset: -5, DST: true },
			{name: 'LD4', offset: 0, DST: true },
			{name: 'Los Angeles', offset: -2, DST: true },
			{name: 'Tokyo', offset: 9, DST: false },
		];

		return (
			<DatePicker
				hintText="Portrait Dialog"
				timeOffset={timeOffset}/>

		);
	},

	//////////////
	// Toolbar //
	//////////////

	_renderToolbar() {
		return(
			<Toolbar ref="toolbar" fixed="bottom">
				<ToolbarGroup align="left">
					<IconButton icon="user" tooltip="Options" />
					<IconButton icon="cog" tooltip="Options" />
				</ToolbarGroup>
				<ToolbarGroup align="center">
					<IconButton active={true} icon="filter" tooltip="Filter" onClick={this._clickFilter} />
					<IconButton disabled={true} icon="cog" tooltip="Options" onClick={this._clickText} />
				</ToolbarGroup>
				<ToolbarGroup align="right">
					<IconButton icon="user" tooltip="Options" />
					<IconButton icon="cog" tooltip="Options" />
				</ToolbarGroup>
			</Toolbar>
		);
	},

	_clickFilter() {
		var toolbar = this.refs.toolbar;
		if(toolbar.state.tray_open) {
			toolbar.closeToolTray();
		} else {
			toolbar.setToolTray(this._filterTools(), 200);
			toolbar.openToolTray();
		}
	},

	_filterTools() {
		return (
			<Container padded={true}>
				<Block width={1} padded={true}>
					<TextField
						hintText="Status"
						floatingLabelText="Status Filter" />
				</Block>
				<Block width={1} padded={true}>
					<TextField
						hintText="Status"/>
				</Block>
				<Block width={1} padded={true}>
					<TextField
						hintText="Status" />
				</Block>
			</Container>
		)
	},

	_clickText() {
		var toolbar = this.refs.toolbar;
		if(toolbar.state.tray_open) {
			toolbar.closeToolTray();
		} else {
			toolbar.setToolTray(this._textTools(), 350);
			toolbar.openToolTray();
		}
	},

	_textTools() {
		return (
			<Container padded={true}>
				<Block width={1} padded={true}>
					<h1>
						Lorem ipsum Reprehenderit do ut aliquip dolor.
					</h1>
					<p>
						Lorem ipsum Id aliqua dolor anim dolor et adipisicing labore est laborum aliquip tempor aliqua dolore ullamco sunt ut fugiat nulla ex dolor tempor dolore occaecat ea sed nostrud mollit id elit est ea sit consequat reprehenderit proident adipisicing aute velit elit labore qui ullamco adipisicing exercitation ut exercitation id minim cillum labore velit consequat dolor ut quis Excepteur anim Ut dolor exercitation Ut nulla Duis sit elit sunt proident tempor quis in minim dolore deserunt in voluptate dolor culpa aute ut magna culpa ex culpa amet officia velit proident officia labore eu dolore dolore aliqua sed veniam proident et nisi dolore ut ut laboris Excepteur do aliqua non voluptate elit sed exercitation occaecat velit deserunt velit mollit ut laboris dolor irure eiusmod eu cillum in eu consectetur ut aute ad eiusmod ex dolor anim voluptate elit labore Ut ut in ut in in ex Duis pariatur ad ad ex qui consequat do incididunt culpa deserunt aliquip ex et nulla velit do in occaecat eu deserunt dolor ex proident sit id Duis in est laboris et proident sint dolor ad voluptate aute voluptate officia do.
					</p>
				</Block>
				<Block width={1} padded={true}>
					<h1>
						Lorem ipsum Reprehenderit do ut aliquip dolor.
					</h1>
					<p>
						Lorem ipsum Id aliqua dolor anim dolor et adipisicing labore est laborum aliquip tempor aliqua dolore ullamco sunt ut fugiat nulla ex dolor tempor dolore occaecat ea sed nostrud mollit id elit est ea sit consequat reprehenderit proident adipisicing aute velit elit labore qui ullamco adipisicing exercitation ut exercitation id minim cillum labore velit consequat dolor ut quis Excepteur anim Ut dolor exercitation Ut nulla Duis sit elit sunt proident tempor quis in minim dolore deserunt in voluptate dolor culpa aute ut magna culpa ex culpa amet officia velit proident officia labore eu dolore dolore aliqua sed veniam proident et nisi dolore ut ut laboris Excepteur do aliqua non voluptate elit sed exercitation occaecat velit deserunt velit mollit ut laboris dolor irure eiusmod eu cillum in eu consectetur ut aute ad eiusmod ex dolor anim voluptate elit labore Ut ut in ut in in ex Duis pariatur ad ad ex qui consequat do incididunt culpa deserunt aliquip ex et nulla velit do in occaecat eu deserunt dolor ex proident sit id Duis in est laboris et proident sint dolor ad voluptate aute voluptate officia do.
					</p>
				</Block>
				<Block width={1} padded={true}>
					<h1>
						Lorem ipsum Reprehenderit do ut aliquip dolor.
					</h1>
					<p>
						Lorem ipsum Id aliqua dolor anim dolor et adipisicing labore est laborum aliquip tempor aliqua dolore ullamco sunt ut fugiat nulla ex dolor tempor dolore occaecat ea sed nostrud mollit id elit est ea sit consequat reprehenderit proident adipisicing aute velit elit labore qui ullamco adipisicing exercitation ut exercitation id minim cillum labore velit consequat dolor ut quis Excepteur anim Ut dolor exercitation Ut nulla Duis sit elit sunt proident tempor quis in minim dolore deserunt in voluptate dolor culpa aute ut magna culpa ex culpa amet officia velit proident officia labore eu dolore dolore aliqua sed veniam proident et nisi dolore ut ut laboris Excepteur do aliqua non voluptate elit sed exercitation occaecat velit deserunt velit mollit ut laboris dolor irure eiusmod eu cillum in eu consectetur ut aute ad eiusmod ex dolor anim voluptate elit labore Ut ut in ut in in ex Duis pariatur ad ad ex qui consequat do incididunt culpa deserunt aliquip ex et nulla velit do in occaecat eu deserunt dolor ex proident sit id Duis in est laboris et proident sint dolor ad voluptate aute voluptate officia do.
					</p>
				</Block>
			</Container>
		);
	},

	////////////
	// Tabs  //
	////////////

	_renderTabs() {
		return (
			<Paper>
				<Tabs>
					<Tab label="Item One" >
						<div className="tab-template-container">
							<h2 className="lui-font-style-headline">Tab One Template Example</h2>
							<p>
								This is an example of a tab template!
							</p>
							<p>
								You can put any sort of HTML or react component in here.
							</p>
						</div>
					</Tab>
					<Tab label="Item Two" disabled={true} >
						<div className="tab-template-container">
							<h2 className="lui-font-style-headline">Tab Two Template Example</h2>
							<p>
								This is another example of a tab template!
							</p>
							<p>
								Fair warning - the next tab routes to home!
							</p>
						</div>
					</Tab>
					<Tab
						label="Item Three"
						route="home"
						onActive={this._onActive} />

				</Tabs>
			</Paper>
		);
	},

	_onActive(tab){
		console.log('Tab 3 Active')
	},

});






/** WEBPACK FOOTER **
 ** ./examples/ComponentsView.js
 **/